module.exports = __webpack_public_path__ + "media/steps/carq_spinner_3_old-a77cb864.png";